// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row .col label {
  color: #4b58a6;
  font-weight: bold;
  padding-right: 3%;
}
h2 {
  background: #e1dbe2;
  margin: 0;
  padding: 15px;
  font-size: 16px;
  font-weight: 400;
  justify-content: space-between;
  align-items: center;
}
/* ===== Refactored Payroll Sync layout ===== */
.ps-record + .ps-record {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 2px dashed rgba(75, 88, 166, 0.25);
}
.ps-trust-banner {
  display: flex;
  align-items: center;
  background: #eaf6ee;
  border-left: 4px solid #2e8b57;
  color: #2e8b57;
  font-weight: 700;
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 13px;
}
.ps-trust-banner .ps-trust-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #2e8b57;
  color: #fff;
  border-radius: 50%;
  margin-right: 8px;
  font-weight: 700;
}
.ps-trust-banner small {
  color: #4a6e57;
  font-weight: 500;
}
.ps-sop-banner .ps-sop-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0 0 1px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #e5e5e5;
}
.ps-sop-banner .ps-sop-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}
.ps-sop-banner .ps-sop-content strong {
  display: block;
  margin-bottom: 0.25rem;
}
.ps-sop-banner .ps-sop-content p {
  margin: 0;
  font-size: 0.85rem;
  color: #171717;
}
.ps-section {
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  background: #fff;
}
.ps-section .row {
  margin-bottom: 6px;
}
.ps-section .row:last-child {
  margin-bottom: 0;
}
.ps-section-title {
  margin: 0 0 10px 0;
  padding-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #4b58a6;
  border-bottom: 1px solid rgba(75, 88, 166, 0.2);
}
.ps-employment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #eef0fb 0%, #f7f5fb 100%);
  border-left: 4px solid #4b58a6;
}
.ps-employment-header .ps-employer-name {
  font-size: 18px;
  font-weight: 700;
  color: #2e3a7a;
}
.ps-employment-header .ps-employee-name {
  font-size: 14px;
  color: #444;
  margin-top: 2px;
}
.ps-employment-header .ps-position {
  color: #666;
  font-style: italic;
}
.ps-pay-section {
  background: #fffaf1;
  border-left: 4px solid #f7ad43;
}
.ps-income-section {
  background: #f1faf3;
  border-left: 4px solid #4caf50;
}
.ps-emphasize {
  font-weight: 700;
  color: #2e3a7a;
}
.ps-status-badge {
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  background: #888;
}
.ps-status-badge.status-active {
  background: #2e8b57;
}
.ps-status-badge.status-inactive {
  background: #c0392b;
}
.ps-status-badge.status-other {
  background: #888;
}
.ps-mismatch {
  border-radius: 4px !important;
  text-align: left !important;
}
.ps-mismatch ul {
  margin: 6px 0 0 18px;
  padding: 0;
}
/* Paystub table */
.ps-paystub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ps-paystub-header .ps-section-title {
  border-bottom: none;
  padding-bottom: 0;
  margin: 0;
}
.ps-paystub-header .ps-coverage {
  font-size: 12px;
  color: #555;
}
.ps-paystub-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 8px;
}
.ps-paystub-table th,
.ps-paystub-table td {
  padding: 6px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  vertical-align: top;
}
.ps-paystub-table th {
  text-align: left;
  color: #4b58a6;
  background: #f4f3f9;
  font-weight: 700;
}
.ps-paystub-table tfoot td {
  background: #fafafa;
  border-top: 2px solid rgba(75, 88, 166, 0.3);
  border-bottom: none;
}
.ps-paystub-table .text-right {
  text-align: right;
}
.ps-paystub-table .text-center {
  text-align: center;
}
.ps-paystub-table .ps-outlier {
  background: #fff4f0;
}
.ps-paystub-table .ps-neg {
  color: #c0392b;
}
.ps-paystub-table .ps-pos {
  color: #2e8b57;
}
.ps-paystub-table .ps-sub {
  font-size: 11px;
  color: #777;
  font-weight: 400;
}
.ps-flags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.ps-flag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #fff;
}
.ps-flag.ps-flag-outlier {
  background: #c0392b;
}
.ps-flag.ps-flag-gap {
  background: #f7ad43;
  color: #5a3d00;
}
small {
  color: #777;
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/income-stream-components/payroll-sync/payroll-sync.component.less"],"names":[],"mappings":"AAGA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AAFJ;AAIA;EACI,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AAFJ;AACA,+CAA+C;AAK/C;EACI,gBAAA;EACA,iBAAA;EACA,8CAAA;AAHJ;AAMA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;AALA;EAYQ,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAJR;AAjBA;EAuBY,cAAA;EAAgB,gBAAA;AAF5B;AAKA;EAEI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;AAJJ;AAJA;EAUiB,kBAAA;EAAoB,cAAA;AAFrC;AARA;EAYa,cAAA;EAAgB,sBAAA;AAA7B;AAZA;EAaQ,SAAA;EAAW,kBAAA;EAAoB,cAAA;AAIvC;AAAA;EACI,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AAPA;EAOW,kBAAA;AAGX;AAH+B;EAAe,gBAAA;AAM9C;AAHA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,+CAAA;AAKJ;AAFA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4DAAA;EACA,8BAAA;AAIJ;AATA;EAOwB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAO3D;AAdA;EAQwB,eAAA;EAAiB,WAAA;EAAa,eAAA;AAWtD;AAnBA;EASmB,WAAA;EAAa,kBAAA;AAchC;AAXA;EAAqB,mBAAA;EAAqB,8BAAA;AAe1C;AAdA;EAAqB,mBAAA;EAAqB,8BAAA;AAkB1C;AAhBA;EAAgB,gBAAA;EAAkB,cAAA;AAoBlC;AAlBA;EACI,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAoBJ;AAlBI;EAAoB,mBAAA;AAqBxB;AApBI;EAAoB,mBAAA;AAuBxB;AAtBI;EAAoB,gBAAA;AAyBxB;AAtBA;EACI,6BAAA;EACA,2BAAA;AAwBJ;AA1BA;EAGS,oBAAA;EAAsB,UAAA;AA2B/B;AACA,kBAAkB;AAxBlB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA0BJ;AA7BA;EAKwB,mBAAA;EAAqB,iBAAA;EAAmB,SAAA;AA6BhE;AAlCA;EAMmB,eAAA;EAAiB,WAAA;AAgCpC;AA7BA;EACI,WAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AA+BJ;AAnCA;;EAOQ,iBAAA;EACA,4CAAA;EACA,mBAAA;AAgCR;AAzCA;EAYQ,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAgCR;AA/CA;EAkBQ,mBAAA;EACA,4CAAA;EACA,mBAAA;AAgCR;AApDA;EAuBmB,iBAAA;AAgCnB;AAvDA;EAwBmB,kBAAA;AAkCnB;AA1DA;EA0BoB,mBAAA;AAmCpB;AA7DA;EA2BoB,cAAA;AAqCpB;AAhEA;EA4BoB,cAAA;AAuCpB;AAnEA;EA8BoB,eAAA;EAAiB,WAAA;EAAa,gBAAA;AA0ClD;AAvCA;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAyCJ;AAvCA;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AAyCJ;AAvCI;EAAoB,mBAAA;AA0CxB;AAzCI;EAAoB,mBAAA;EAAqB,cAAA;AA6C7C;AA1CA;EACI,WAAA;EACA,eAAA;AA4CJ","sourcesContent":["@import (reference) url('../../../../styles.less');\n\n\n.row .col label{\n    color: #4b58a6;\n    font-weight: bold;\n    padding-right: 3%;\n}\nh2{\n    background: #e1dbe2;\n    margin:0;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* ===== Refactored Payroll Sync layout ===== */\n.ps-record + .ps-record {\n    margin-top: 24px;\n    padding-top: 16px;\n    border-top: 2px dashed rgba(75, 88, 166, 0.25);\n}\n\n.ps-trust-banner {\n    display: flex;\n    align-items: center;\n    background: #eaf6ee;\n    border-left: 4px solid #2e8b57;\n    color: #2e8b57;\n    font-weight: 700;\n    padding: 8px 12px;\n    margin-bottom: 12px;\n    font-size: 13px;\n\n    .ps-trust-icon {\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        text-align: center;\n        background: #2e8b57;\n        color: #fff;\n        border-radius: 50%;\n        margin-right: 8px;\n        font-weight: 700;\n    }\n    small { color: #4a6e57; font-weight: 500; }\n}\n\n.ps-sop-banner {\n  .ps-sop-alert {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    margin: 0 0 1px;\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid #e5e5e5;\n  }\n  .ps-sop-icon { font-size: 1.25rem; flex-shrink: 0; }\n  .ps-sop-content {\n    strong { display: block; margin-bottom: 0.25rem; }\n    p { margin: 0; font-size: 0.85rem; color: #171717; }\n  }\n}\n\n.ps-section {\n    padding: 12px 14px;\n    margin-bottom: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 4px;\n    background: #fff;\n\n    .row { margin-bottom: 6px; &:last-child { margin-bottom: 0; } }\n}\n\n.ps-section-title {\n    margin: 0 0 10px 0;\n    padding-bottom: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #4b58a6;\n    border-bottom: 1px solid rgba(75, 88, 166, 0.2);\n}\n\n.ps-employment-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: linear-gradient(90deg, #eef0fb 0%, #f7f5fb 100%);\n    border-left: 4px solid #4b58a6;\n\n    .ps-employer-name { font-size: 18px; font-weight: 700; color: #2e3a7a; }\n    .ps-employee-name { font-size: 14px; color: #444; margin-top: 2px; }\n    .ps-position { color: #666; font-style: italic; }\n}\n\n.ps-pay-section    { background: #fffaf1; border-left: 4px solid #f7ad43; }\n.ps-income-section { background: #f1faf3; border-left: 4px solid #4caf50; }\n\n.ps-emphasize { font-weight: 700; color: #2e3a7a; }\n\n.ps-status-badge {\n    padding: 6px 14px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #fff;\n    background: #888;\n\n    &.status-active   { background: #2e8b57; }\n    &.status-inactive { background: #c0392b; }\n    &.status-other    { background: #888; }\n}\n\n.ps-mismatch {\n    border-radius: 4px !important;\n    text-align: left !important;\n    ul { margin: 6px 0 0 18px; padding: 0; }\n}\n\n/* Paystub table */\n.ps-paystub-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .ps-section-title { border-bottom: none; padding-bottom: 0; margin: 0; }\n    .ps-coverage { font-size: 12px; color: #555; }\n}\n\n.ps-paystub-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    margin-top: 8px;\n\n    th, td {\n        padding: 6px 10px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n        vertical-align: top;\n    }\n    th {\n        text-align: left;\n        color: #4b58a6;\n        background: #f4f3f9;\n        font-weight: 700;\n    }\n    tfoot td {\n        background: #fafafa;\n        border-top: 2px solid rgba(75, 88, 166, 0.3);\n        border-bottom: none;\n    }\n\n    .text-right  { text-align: right; }\n    .text-center { text-align: center; }\n\n    .ps-outlier   { background: #fff4f0; }\n    .ps-neg       { color: #c0392b; }\n    .ps-pos       { color: #2e8b57; }\n\n    .ps-sub       { font-size: 11px; color: #777; font-weight: 400; }\n}\n\n.ps-flags {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n.ps-flag {\n    display: inline-block;\n    padding: 2px 6px;\n    border-radius: 3px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #fff;\n\n    &.ps-flag-outlier { background: #c0392b; }\n    &.ps-flag-gap     { background: #f7ad43; color: #5a3d00; }\n}\n\nsmall {\n    color: #777;\n    font-size: 11px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
